import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  title: 'Mapa de Proveedores "Argentina Low-Cost"',
  desc: 'El error del principiante es comprar en la ferretería del barrio. Acá revelamos dónde comprar cementos especiales, pigmentos importados y selladores industriales en Argentina a los mejores precios, con contacto directo de distribuidores y envío a todo el país.',
  price: '$8.500'
}, {
  n: '02',
  title: 'Smart-Cost Cemento: Calculadora de Ganancia Neta',
  desc: 'Planilla automatizada: cargás el precio de la bolsa de cemento y el tamaño del molde, y te devuelve cuánto te costó fabricarlo y a cuánto venderlo para ganar un 300%. Considera inflación, Mercado Pago, envíos y packaging.',
  price: '$6.000'
}, {
  n: '03',
  title: 'Estética Boutique: Fotografía de Catálogo con Celular',
  desc: 'La gente no compra cemento, compra estilo de vida. Aprendé a crear escenarios tipo Pinterest con luz natural y fondos baratos que ya tenés en casa, para que tus fotos parezcan de una revista de diseño escandinavo.',
  price: '$12.000'
}, {
  n: '04',
  title: 'Insta-Venta Pack: 20 Plantillas de Instagram',
  desc: 'No pierdas tiempo diseñando desde cero. 20 plantillas editables en Canva con estética minimalista industrial: subís la foto de tu pieza y ya tenés historias y posts que generan consultas de precio en menos de 24 horas.',
  price: '$9.500'
}, {
  n: '05',
  title: 'Masterclass Veteado: El Efecto Mármol que Duplica tu Precio',
  desc: 'Guía ultra-específica para lograr el veteado perfecto sin que los colores se mezclen y queden "sucios". Las piezas con efecto mármol se venden hasta un 50% más caras que las lisas.',
  price: '$15.000'
}];
export function Bonuses() {
  return <section aria-label="Bonos" className="border-y border-white/5 bg-ink-2" data-id="element-14" data-mp="no6phimu76na">
      <div className="mx-auto max-w-5xl px-5 pb-[22px]" data-id="element-15" data-mp="iq55mvhl73ar">
        <h2 className="pt-[28px] text-center font-display text-2xl font-black text-white sm:text-4xl" data-id="element-16" data-mp="3cj6iqhppjyqy">
          🎁 5 Bonos estratégicos — siempre incluidos
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="3hk404s2w8ore">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-gold/25 bg-ink p-6" data-id="element-18" data-mp="3lhi68ava2gf6" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-19" data-mp="32sbmqlmntksb">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-bold text-gold" data-id="element-20" data-mp="37kv6k0bxxc5k">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="2a460tvjvdpqw" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="2f1y1pf2hsm78">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="27kjet4kwonod">{b.price}</span>{' '}
                  <span className="text-cemento-soft" data-id="element-24" data-mp="22kwyundp0tbv">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="1xlk3fe8radxo">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="1xnofwkkq0l9k">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-cemento/30 bg-white/5 p-6 text-center" data-id="element-27" data-mp="1olnmjyslyjd6">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="1jtx4f6nfirb7">
            💰 Valor total de los bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-29" data-mp="1ewds4caakolw">$51.000</span>{' '}
            <span className="text-[15px] text-gold" data-id="element-30" data-mp="19wiyi0z4tkx5">HOY GRATIS CON TU ACADEMIA</span>
          </p>
        </div>
      </div>
    </section>;
}